import { useMemo } from 'react';
import { AssetTypes } from './CMSParams';
import { useStudioContext } from './useStudioContext';

export const useTemplateSaveAssetTypes = (preferredAssetType) => {
  const {
    assetType,
    contentBankAssetType,
    cardsAssetType,
    templateAssetTypes,
  } = useStudioContext();

  return useMemo(() => {
    if (assetType === AssetTypes.Template) {
      return Array.isArray(templateAssetTypes)
        ? templateAssetTypes.filter(
            (templateAssetType) =>
              templateAssetType && templateAssetType !== AssetTypes.Template
          )
        : [];
    }

    const saveAssetType =
      preferredAssetType || contentBankAssetType || cardsAssetType || assetType;

    return saveAssetType ? [saveAssetType] : [];
  }, [
    assetType,
    cardsAssetType,
    contentBankAssetType,
    preferredAssetType,
    templateAssetTypes,
  ]);
};
